import { CommonModule } from '@angular/common'
import { Component, computed, input, output } from '@angular/core'

import { FeedbackType } from '@flowx/designer/modules/ai/types/ai.types'

import { AiIconsModule } from '../../../../common/icons/ai-icons.module'

@Component({
  selector: 'flx-ai-feedback-actions',
  imports: [CommonModule, AiIconsModule],
  templateUrl: './ai-feedback-actions.component.html',
  styleUrl: './ai-feedback-actions.component.scss',
})
export class AiFeedbackActionsComponent {
  FeedbackType = FeedbackType

  feedback = input<FeedbackType | null>(null)

  sendFeedback = output<FeedbackType>()

  isFeedbackType = computed(() => {
    const feedback = this.feedback()

    return {
      [FeedbackType.POSITIVE]: feedback === FeedbackType.POSITIVE,
      [FeedbackType.NEGATIVE]: feedback === FeedbackType.NEGATIVE,
    }
  })

  canSendFeedback = computed(() => !this.feedback())

  submitFeedback(feedbackType: FeedbackType): void {
    if (this.canSendFeedback()) {
      this.sendFeedback.emit(feedbackType)
    }
  }
}
